import React from "react";
import CallToAction from "../base/CallToAction";
import {useNavigate} from "react-router"

const InProcess = () => {

const route = useNavigate()

  return (
    <CallToAction title="Estamos validando tu identidad 🧐" subtitle={<div>Por el momento no puedes pedir ni gastar. Mientras tanto puedes ir agregando tus datos, (tarjetas, cuentas de banco, etc.) </div>} 
    button={{visible:true, title:'Agregar mi información', action:()=>{route('/ProfileOptionsScreen')}}}/>     
  );
};

export default InProcess;
